import Vue from 'vue'
import vmApp from './App.vue'
import store from './store'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

new Vue({
  store,
  render: h => h(vmApp)
}).$mount('#careers-app')
